module.exports = __webpack_public_path__ + "static/media/Banner1.9f431aab.jpeg";